import * as React from 'react';

interface IProps {
  width?: number;
}

export default (props: IProps) => {
  const {width} = props;

  return (
    <svg
      width={width}
      height={width}
      viewBox={`0 0 ${width} ${width}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="50" height="50" rx="25" fill="${color ?? '#0088FF'}" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M37.0672 13.117C37.1804 13.187 37.2738 13.2847 37.3386 13.4009C37.4034 13.5172 37.4374 13.648 37.4375 13.7811V37.2186C37.4375 37.4258 37.3552 37.6245 37.2087 37.771C37.0622 37.9175 36.8635 37.9998 36.6562 37.9998H31.9688C31.7615 37.9998 31.5628 37.9175 31.4163 37.771C31.2698 37.6245 31.1875 37.4258 31.1875 37.2186V34.8748H29.625V37.2186C29.625 37.4258 29.5427 37.6245 29.3962 37.771C29.2497 37.9175 29.051 37.9998 28.8438 37.9998H14.7812C14.574 37.9998 14.3753 37.9175 14.2288 37.771C14.0823 37.6245 14 37.4258 14 37.2186V28.6248C14.0001 28.4609 14.0518 28.3012 14.1477 28.1683C14.2436 28.0354 14.3789 27.936 14.5344 27.8842L23.375 24.9373V20.0311C23.375 19.8861 23.4153 19.744 23.4915 19.6206C23.5677 19.4973 23.6766 19.3976 23.8062 19.3326L36.3062 13.0826C36.4255 13.023 36.558 12.9948 36.6912 13.0008C36.8244 13.0068 36.9538 13.0468 37.0672 13.117ZM23.375 26.5842L15.5625 29.1873V36.4373H23.375V26.5842ZM24.9375 36.4373H28.0625V34.0936C28.0625 33.8864 28.1448 33.6877 28.2913 33.5411C28.4378 33.3946 28.6365 33.3123 28.8438 33.3123H31.9688C32.176 33.3123 32.3747 33.3946 32.5212 33.5411C32.6677 33.6877 32.75 33.8864 32.75 34.0936V36.4373H35.875V15.0451L24.9375 20.5139V36.4373Z"
        fill="white"
      />
      <path
        d="M17.125 30.1875H18.6875V31.75H17.125V30.1875ZM20.25 30.1875H21.8125V31.75H20.25V30.1875ZM17.125 33.3125H18.6875V34.875H17.125V33.3125ZM20.25 33.3125H21.8125V34.875H20.25V33.3125ZM26.5 27.0625H28.0625V28.625H26.5V27.0625ZM29.625 27.0625H31.1875V28.625H29.625V27.0625ZM26.5 30.1875H28.0625V31.75H26.5V30.1875ZM29.625 30.1875H31.1875V31.75H29.625V30.1875ZM32.75 27.0625H34.3125V28.625H32.75V27.0625ZM32.75 30.1875H34.3125V31.75H32.75V30.1875ZM26.5 23.9375H28.0625V25.5H26.5V23.9375ZM29.625 23.9375H31.1875V25.5H29.625V23.9375ZM32.75 23.9375H34.3125V25.5H32.75V23.9375ZM26.5 20.8125H28.0625V22.375H26.5V20.8125ZM29.625 20.8125H31.1875V22.375H29.625V20.8125ZM32.75 20.8125H34.3125V22.375H32.75V20.8125ZM32.75 17.6875H34.3125V19.25H32.75V17.6875Z"
        fill="white"
      />
    </svg>
  );
};
